import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCopilot = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#007AFF"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m15.728 2.229-.96-.96a.907.907 0 0 0-1.29 0L1.269 13.478a.907.907 0 0 0 0 1.29l.96.96a.9.9 0 0 0 1.29 0l12.209-12.21a.9.9 0 0 0 0-1.289M10 5l2 2M3.5 4v3M13.5 10v3M7.5 1v2M5 5.5H2M15 11.5h-3M8 1.5H6" />
    </g>
  </svg>
);
const Memo = memo(SvgCopilot);
export default Memo;
